module.exports = __webpack_public_path__ + "img/external-link.3527f610.svg";